import type { ReactNode } from "react"

interface Props {
  label: ReactNode
  topicLabel?: ReactNode
  axisLabel?: ReactNode
  color?: string
}

export default function SurveyQuestionLabel({ label, topicLabel, axisLabel, color }: Props) {
  return (
    <div className="font-normal">
      {(topicLabel || axisLabel) && (
        <div style={{ fontSize: "12px", color }}>
          {topicLabel && <b>{topicLabel}</b>}
          {topicLabel && axisLabel && " - "}
          {axisLabel}
        </div>
      )}
      <div>{label}</div>
    </div>
  )
}
